import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import { Container } from 'Components/Atoms/ContainerDeprecated/Container';
import ContainerHeader from 'Components/Atoms/Containers/ContainerHeader/ContainerHeader';
import Paper from 'Components/Atoms/Containers/Paper/Paper';
import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import FormSection from 'Components/Molecules/Form/FormSection/FormSection';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ROUTE } from 'Services/Route/Route.types';
import ExtensionHelper from 'Services/Settings/Extensions/ExtensionHelper';
import MailgunHelper from 'Services/Settings/Extensions/Mailgun/MailgunHelper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { createExtension, fetchExtensions, patchExtension } from 'Store/Settings/Extensions/Actions';
import { getExtensionByName } from 'Store/Settings/Extensions/Selectors';
import Field from '../FieldsManagement/Fields/FieldTypes/Field';

const MailgunExtensionPage = ({
    extensionSettings,
    ...props
}: MailgunExtensionProps) => {
    const [state, setState] = useState({
        isEdit: false,
        mailType: ''
    });
    const [data, setData] = useState<any>(extensionSettings?.configuration);

    const handleCancel = () => {
        setState(({ ...state, isEdit: false }));
        setData(extensionSettings?.configuration);
    }
    const handleEdit = (value) => setState({ ...state, isEdit: value });
    const handleChange = (key, value) => setData({
        ...data,
        [state.mailType]: {
            ...data?.[state.mailType],
            [key]: value
        }
    });
    const handleSave = () => {
        const record: any = extensionSettings;

        if (record?.id) {
            props.patchExtension(record?.id, {
                "configuration": {
                    ...record.configuration,
                    ...data
                }
            });

            return;
        }

        props.createExtension({
            "extension": ExtensionHelper.EXTENSIONS.MAILGUN,
            "configuration": data
        });
    }

    useEffect(() => {
        setData(extensionSettings?.configuration);
    }, [extensionSettings?.configuration]);

    useEffect(() => {
        props.fetchExtensions();
    }, []);

    useEffect(() => {
        if (!state.mailType) setState({ ...state, isEdit: false }); 
    }, [state.mailType]);

    return (
        <PageTemplate>
            <Helmet>
                <title>Mailgun - Growing People B.V.</title>
            </Helmet>

            <Container>
                <PageHeader
                    breadcrumbs={
                        <Breadcrumbs>
                            <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                            <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                            <BreadcrumbItem>Mailgun</BreadcrumbItem>
                        </Breadcrumbs>
                    }
                />

                <ContainerHeader title={'Algemeen'}>
                    <EditButtons
                        onEdit={(value) => setState({...state, isEdit: value})}
                        onSave={() => {}}
                        onCancel={() => {}}
                    />
                </ContainerHeader>

                <Paper>
                    <RowItem>
                        <RowItemTitle>API key</RowItemTitle>
                        <RowItemInfo>
                            Currently
                            {/* <DisplayName
                                entity={entity}
                                value={data?.name_fields}
                                isEdit={state.isEdit}
                                onChange={(value: any) => setData({...data, name_fields: value})}
                            /> */}
                        </RowItemInfo>
                    </RowItem>
                    <RowItem>
                        <RowItemTitle>Sending domain</RowItemTitle>
                        <RowItemInfo>
                            Under
                            {/* <DisplayName
                                entity={entity}
                                value={data?.name_fields}
                                isEdit={state.isEdit}
                                onChange={(value: any) => setData({...data, name_fields: value})}
                            /> */}
                        </RowItemInfo>
                    </RowItem>
                    <RowItem>
                        <RowItemTitle>Reply to mailadres</RowItemTitle>
                        <RowItemInfo>
                            Construction
                            {/* <DisplayName
                                entity={entity}
                                value={data?.name_fields}
                                isEdit={state.isEdit}
                                onChange={(value: any) => setData({...data, name_fields: value})}
                            /> */}
                        </RowItemInfo>
                    </RowItem>
                </Paper>

                <br/>

                <ContainerHeader title={'Mail templates'}>
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        width: '300px'
                    }}>
                        <Field
                            isEdit={true}
                            type={FieldType.Select}
                            value={state.mailType}
                            onChange={(value) => setState({...state, mailType: value})}
                            fieldProperties={{
                                list: MailgunHelper.mailTemplatesDataset
                            }}
                        />
                        {
                            state.mailType &&
                            <EditButtons
                                onEdit={handleEdit}
                                onSave={handleSave}
                                onCancel={handleCancel}
                            />
                        }
                    </div>
                </ContainerHeader>

                <Paper>
                    {
                        !state.mailType &&
                        <RowItem>
                            <RowItemTitle>Selecteer een mail template...</RowItemTitle>
                        </RowItem>
                    }
                    {
                        state.mailType
                        && <div style={{ padding: '24px 0' }}>
                            <FormSection>
                                <FormGroup title='Stuur kopie van mail naar afzender'>
                                    <Field
                                        isEdit={state.isEdit}
                                        type={FieldType.Toggle}
                                        onChange={(value) => handleChange('copy_to_sender', value)}
                                        value={data?.[state.mailType]?.copy_to_sender}
                                    />
                                </FormGroup>
                                <FormGroup title='Template'>
                                    <Field
                                        isEdit={state.isEdit}
                                        type={FieldType.HTML_Editor}
                                        onChange={(value) => handleChange('template', value)}
                                        value={data?.[state.mailType]?.template}
                                    />
                                </FormGroup>
                            </FormSection>
                        </div>
                    }
                </Paper>
            </Container>
        </PageTemplate>
    )
}
interface Props {
    
};

const mapState = (state: StoreState) => ({
    extensionSettings: getExtensionByName(state, ExtensionHelper.EXTENSIONS.MAILGUN)
});

const mapDispatch = {
    fetchExtensions,
    createExtension,
    patchExtension
};

type MailgunExtensionProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(MailgunExtensionPage);